import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { CoreBanner, CoreButton } from "@verity/components/core";
import { isAdmin } from "../../shared";
import { PortalControllerContext } from "../../context";
import { getLmsName } from "../../../helpers/lms-name";
import styles from "./index.module.css";

export default function VisualizerBanner() {
	const { dismissUiElement, openQuickSetupGuide, portalContext, userPrivileges, dismissableUiElements } =
		useContext(PortalControllerContext);
	const { lms } = portalContext;
	const { i18n } = useTranslation();
	const shouldRenderBanner = dismissableUiElements.has("visualizerBanner") && isAdmin(userPrivileges, portalContext);
	const lmsName = getLmsName(lms);

	if (!shouldRenderBanner) return null;

	return (
		<div className={styles.portalBannerWrapper}>
			<CoreBanner
				onClose={() => dismissUiElement("visualizerBanner")}
				slotProps={{ bodyWrapper: { className: styles.portalBannerContent } }}
				label={i18n.t("portal.components.visualizerBannerTSX.installIntegration", { lms: lmsName })}
			>
				<div className={styles.portalBannerButton}>
					<CoreButton
						component="a"
						style={{ minWidth: "fit-content" }}
						onClick={() => {
							openQuickSetupGuide(true);
							dismissUiElement("visualizerBanner");
						}}
					>
						{i18n.t("portal.components.visualizerBannerTSX.viewIntegrationButton")}
					</CoreButton>
				</div>
			</CoreBanner>
		</div>
	);
}
